import { ErrorToResend, StatusCodes, ErrorThatCantBeSent } from "../types";
import { areStatusCodesInvalid } from "./areStatusCodesInvalid";
import { HandleErrorResendingArgs } from "./types";
import { validateStatusCodes } from "./validateStatusCodes";

interface HandleStatusCodesArgs {
  errorData: ErrorToResend;
  handleErrorResending: (props: HandleErrorResendingArgs) => void;
  errorsThatCantBeSent: ErrorThatCantBeSent[];
}

export const handleStatusCodes = ({ errorData, handleErrorResending, errorsThatCantBeSent }: HandleStatusCodesArgs) => {
  const { bid: validBidStatusCode, ask: validAskStatusCode } = validateStatusCodes(errorData.statusCodes);

  if (areStatusCodesInvalid(validBidStatusCode, validAskStatusCode)) {
    const statusCodes: StatusCodes = {};

    if (errorData.statusCodes.bid) statusCodes.bid = errorData.statusCodes.bid;
    if (errorData.statusCodes.ask) statusCodes.ask = errorData.statusCodes.ask;

    handleErrorResending({ errorData, row: errorData.security.row, statusCodes, errorsThatCantBeSent });
    return false;
  }

  return { validBidStatusCode, validAskStatusCode };
};
